<script setup lang="ts">
import type { DataTableCellProps } from '@common';
import type { DecisionSupportZoneData } from '../../models';
import { computed, toRefs } from 'vue';

const props = defineProps<DataTableCellProps<any, DecisionSupportZoneData>>();
const { item } = toRefs(props);

const yieldHectareValue = computed(() => {
  return (item.value.data.yieldValue / 1000).toFixed(2);
});
</script>

<template>
  <div>{{ yieldHectareValue }} t/ha</div>
</template>
